export default {
  app: {
    name: "EpicPH后台",
    full: "EpicPH后台",
    minimized: "EPBO"
  },
  welcome: "欢迎回来，{user}!",
  login: "登录到您的帐户",
  relogin: "请重新登录到您的帐户。",
  expired: "会话已过期!",
  denied: "权限被拒绝!",
  success: "您已成功完成!",
  search_by_id_name: "按ID或名称搜索",
  search_by_id: "按ID搜索",
  search_by_full_id: "按完整ID搜索",
  change_user_status_confirm: "您确定要更改帐户状态吗？",
  delete_confirm: "您确定要删除{name}吗？",
  successful_change_password: "您已成功更改密码。",
  change_disable_confirm: "您确定要更改\"{name}\"为禁用吗？",
  select_option: "选择您的选项",
  no_data_available: "没有可用数据",
  no_rating_available: "没有可用评级",
  successful_update_security: "您已成功更新安全性。",
  successful_disable_security: "您已成功禁用安全性。",
  update_security_confirm: "您确定要更新安全性吗？",
  disable_security_confirm: "您确定要禁用安全性吗？",
  change_operator_status_confirm: "您确定要更改运营商\"\"{name}\"状态吗？",
  change_member_status_confirm: "您确定要更改会员\"\"{name}\"状态吗？",
  approve_ticket_confirm: "您确定要批准该工单吗？",
  reject_ticket_confirm: "您确定要拒绝该工单吗？",
  change_self_operate_confirm: "您确定要更改\"{name}\"操作模式吗？",
  change_bank_account_status_confirm: "您确定要更改\"{name}\"帐户状态吗？",
  change_ibank_account_status_confirm: "您确定要更改\"{name}\"帐户状态吗？",
  change_promo_status_confirm: "您确定要更改\"{name}\"促销状态吗？",
  change_promo_signup_status_confirm: "您确定要更改\"{name}\"促销注册状态吗？",
  knock_off_promo_confirm: "您确定要撤销\"{name}\"促销吗？",
  successful_promo_package_download: "您已成功下载促销套餐。",
  successful_update_account_setup: "您已成功更新帐户设置。",
  unblock_member_confirm: "您确定要解锁会员\"{name}\"吗？",
  unblock_operator_confirm: "您确定要解锁运营商\"{name}\"吗？",
  block_sub_account_confirm: "您确定要封锁子帐户\"{name}\"吗？",
  unblock_sub_account_confirm: "您确定要解锁子帐户\"{name}\"吗？",
  successful_create_secondary_account: "您已成功创建辅助帐户。",
  update_account_password_confirm: "您确定要更新帐户密码吗？",
  successful_update_account_password: "您已成功更新帐户密码。",
  update_account_password_cancel: "您确定要取消更新帐户密码吗？",
  change_affiliate_status_confirm: "您确定要更改联盟\"{name}\"状态吗？",
  approve_affiliate_confirm: "您确定要批准\"{name}\"为联盟吗？",
  unblock_affiliate_confirm: "您确定要解锁联盟\"{name}\"吗？",
  change_coupon_status_confirm: "您确定要更改\"{name}\"优惠券状态吗？",
  submit_acknowledgement_confirm: "您确定要提交确认吗？",
  change_bank_group_default_confirm: "您确定要将\"{name}\"设置为默认银行组吗？",
  change_withdrawal_limit_default_confirm: "您确定要将\"{name}\"设置为默认提款限额吗？",
  change_promotion_group_default_confirm: "您确定要将\"{name}\"设置为默认促销组吗？",
  change_referral_status_confirm: "您确定要更改\"{name}\"推荐状态吗？",
  change_withdrawal_limit_confirm: "您确定要更改\"{name}\"提款限额吗？",
  change_promotion_group_confirm: "您确定要更改\"{name}\"促销组吗？",
  change_bank_group_confirm: "您确定要更改\"{name}\"银行组吗？",
  change_member_bet_limit_confirm: "您确定要更改\"{name}\" \"{provider}\"投注限额吗？",
  assign_free_credit_confirm: "您确定要为\"{name}\"分配免费信用吗？",
  update_survey_status_confirm: "您确定要更新调查状态吗？",
  move_banner_up_confirm: "您确定要将横幅\"{name}\"上移吗？",
  move_banner_down_confirm: "您确定要将横幅\"{name}\"下移吗？",
  delete_banner_confirm: "您确定要删除横幅\"{name}\"吗？",
  change_banner_status_confirm: "您确定要更改横幅\"{name}\"状态吗？",
  delete_page_confirm: "您确定要删除页面\"{name}\"吗？",
  change_page_status_confirm: "您确定要更改页面\"{name}\"状态吗？",
  clear_maintenance_time_confirm: "您确定要清除\"{name}\"维护时间吗？",
  successful_clear_outstanding: "您已成功清除{amt}的未结余额。",
  clear_outstanding_confirm: "您确定要清除\"{name}\"未结余额吗？",
  trace_outstanding_confirm: "您确定要跟踪\"{name}\"未结余额吗？",
  change_setting_confirm: "您确定要更改\"{name}\"设置吗？",
  add_bonus_list_member_confirm: "您确定要将所选会员添加到奖金列表吗？",
  delete_bonus_list_member_confirm: "您确定要从奖金列表中删除所选会员吗？",
  delete_ip_address_confirm: "您确定要删除\"{name}\"下的IP地址\"{ip}\"吗？",
  add_ip_address_confirm: "您确定要在\"{name}\"下添加IP地址\"{ip}\"吗？",
  change_payment_mode_status_confirm: "您确定要更改\"{name}\"支付方式状态吗？",
  change_provider_group_status_confirm: "您确定要更改\"{mode}\"下的\"{group}\"状态吗？",
  bulk_issue_bonus_member_confirm: "您确定要向奖金列表中的会员发放奖金吗？",
  change_provider_group_recommend_confirm: "您确定要更改\"{mode}\"下的\"{group}\"推荐吗？",
  change_provider_group_seq_confirm: "您确定要更改\"{mode}\"下的\"{group}\"顺序吗？",
  no_member_found: "没有找到会员",
  redeposit_ticket_confirm: "您确定要重新存款工单吗？",
  change_provider_group_limit_confirm: "您确定要更改\"{mode}\"下的\"{group}\"限额吗？",
  audit_ticket_confirm: "您确定要审核该工单吗？",
  review_ticket_confirm: "您确定要审查该工单吗？",
  change_promotion_group_seq_confirm: "您确定要更改\"{promotion}\"下的\"{group}\"顺序吗？",
  unlock_custom_vip_confirm: "您确定要解锁\"{name}\"定制vip吗?",
  move_affiliate_confirm: "您确定要将\"{name}\"整个分支联盟迁移到公司吗?",
  change_payment_mode_seq_confirm: "您确定要更改\"{mode}\"的顺序吗？",
  remove_bank_default_provider_confirm: "您确定要移除\"{bank}\"默认提供商?",
  change_label_status_confirm: "您确定要更改\"{name}\"标签状态吗？",
  clear_iframe_url_confirm: "您确定要清除内嵌框架网址吗？",
  adjust_balance_remark: "可输入减号（-）从会员钱包中扣除余额。",

  change_vip_default_confirm: "您确定要更改\"{name}\"为默认VIP吗？",
  move_vip_confirm: "您确定要将\"{name}\"更改为位置\"{position}\"吗?",
  delete_turnover_tier_confirm: "您确定要删除\"{name}\"营业额等级吗？",
  vip_provider_rebate_batch_confirm: "您是否确认继续进行VIP提供商返利批量更新?",

  delete_game_exclude_confirm: "您确定要删除\"{provider}\"下的\"{name}\"游戏吗？",
};
